import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GeneralDialogComponent } from '../components/dialogos/general/general-dialog.component';

@Injectable()
export class NotificationsService {

  constructor(
    private dialog: MatDialog
  ) { }

  showInfo(message: string, title: string = "Información", icon: string = 'peligro.png', textButton: string = 'Entendido'): MatDialogRef<GeneralDialogComponent> {
    const config = {
      disableClose: true,
      data: {
        icon: icon ? icon : 'peligro.png',
        centerContent: true,
        title: title ? title : "Información",
        subtitle: "",
        content: `<p>${message}</p>`,
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
          {
            text: textButton,
            class: "general-button",
            value: true
          }
        ],
        showExampleStepper: false
      }
    };
    return this.dialog.open(GeneralDialogComponent, config);
  }

  showError(message: string, icon: string = 'e-peligro.png'): MatDialogRef<GeneralDialogComponent> {
    const config = {
      disableClose: true,
      data: {
        icon: icon,
        centerContent: true,
        title: "Error",
        subtitle: "",
        content: `<p>${message}</p>`,
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
          {
            text: "Entendido",
            class: "general-button",
            value: true
          }
        ],
        showExampleStepper: false
      }
    };
    return this.dialog.open(GeneralDialogComponent, config);
  }

  showConfirm(message: string, icon: string = 'e-peligro.png', buttonText?: string): MatDialogRef<GeneralDialogComponent> {
    const config = {
      disableClose: true,
      data: {
        icon: icon,
        centerContent: true,
        title: "Atención",
        subtitle: "",
        content: `<p>${message}</p>`,
        textButtons: ``,
        orientationButtons: 'horizontal',
        buttons: [
          {
            text: buttonText!==null ? buttonText : "Sí, Continuar",
            class: "general-button",
            value: true
          }
        ],
        showExampleStepper: false
      }
    };
    return this.dialog.open(GeneralDialogComponent, config);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/services/notifications.service.ts